module.exports = __webpack_public_path__ + "img/everyday-repay.9e87120a.svg";